export interface GoogleAnalyticsConfig {
    [siteId: string]: string;
}

export const GA_CONFIG: GoogleAnalyticsConfig = {
    '606': 'G-CJGR6V75VQ',
};

export function loadGoogleAnalytics(siteId: string): void {
    const gaId = GA_CONFIG[siteId];
    
    if (!gaId) {
        console.log(`No Google Analytics ID configured for site: ${siteId}`);
        return;
    }

    if (typeof window === 'undefined') {
        return;
    }

    if ((window as any).gtag) {
        console.log('Google Analytics already loaded');
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    
    script.onload = () => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(...args: any[]) {
            (window as any).dataLayer.push(args);
        }
        (window as any).gtag = gtag;
        
        gtag('js', new Date());
        gtag('config', gaId);
        
        console.log(`Google Analytics loaded for site ${siteId} with ID: ${gaId}`);
    };

    script.onerror = () => {
        console.error(`Failed to load Google Analytics for site ${siteId}`);
    };

    document.head.appendChild(script);
}